import { createContext, useContext } from 'react';
import type { Draw } from '@/lib/drawHistory';
import type { AdvancedFilters, StatsSummary } from '@/lib/statisticsAnalysis';

export interface StatisticsDataValue {
  // 원본 및 카운트
  draws: Draw[];
  periodFilteredDraws: Draw[];
  filteredDraws: Draw[];
  dbCount: number;
  loadedCount: number;
  invalidCount: number;
  incomplete: boolean;
  incompleteReason: string | null;
  loading: boolean;
  error: string;
  retry: () => void;
  // 파생 통계
  frequencyData: Map<number, number>;
  hotNumbers: number[];
  coldNumbers: number[];
  hotCombination: { numbers: number[]; bonus: number };
  coldCombination: { numbers: number[]; bonus: number };
  statsSummary: StatsSummary | null;
  // 필터 메타
  advancedFilters: AdvancedFilters;
  resetFilters: () => void;
}

export const StatisticsDataContext = createContext<StatisticsDataValue | undefined>(
  undefined,
);

export function useStatisticsData(): StatisticsDataValue {
  const ctx = useContext(StatisticsDataContext);
  if (!ctx) {
    throw new Error('useStatisticsData must be used within StatisticsDataProvider');
  }
  return ctx;
}